export const blockIconsActionLock = (
	<span className='material-symbols-outlined'>lock</span>
);
